import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { customerPackagingConfirmationType, packagingContent, packagingGroup, packagingType } from 'global/Models/packaging';
import { packaging } from 'global/Models/packagingModel';

type initialStateType = {
  packagingLoading: boolean;
  packagingContent: packagingContent[] | undefined;
  packagingGroup: packagingGroup[] | undefined;
  packagingType: packagingType[] | undefined;
  packagingConfirmationType: customerPackagingConfirmationType | undefined;
  packagingList: packaging[] | undefined;
};

const initialState: initialStateType = {
  packagingLoading: false,
  packagingContent: undefined,
  packagingGroup: undefined,
  packagingType: undefined,
  packagingConfirmationType: undefined,
  packagingList: undefined,
};

export const packagingSlice = createSlice({
  name: 'packaging',
  initialState,
  reducers: {
    setPackagingLoading: (state, action: PayloadAction<boolean>) => {
      state.packagingLoading = action.payload;
    },
    setPackagingContent: (state, action: PayloadAction<packagingContent[]>) => {
      state.packagingContent = action.payload;
    },
    setPackagingGroup: (state, action) => {
      state.packagingGroup = action.payload;
    },
    setPackagingType: (state, action) => {
      state.packagingType = action.payload;
    },
    setCustomerPackagingConfirmationType: (state, action) => {
      state.packagingConfirmationType = action.payload;
    },
    setPackaging: (state, action) => {
      state.packagingList = action.payload;
    },
  },
});

export const { setPackagingLoading, setPackagingContent, setPackagingGroup, setPackagingType, setCustomerPackagingConfirmationType, setPackaging } = packagingSlice.actions;

export default packagingSlice.reducer;
